const state = {
  activeIndex: 0,
  promotionActiveIndex: 0,
  officialActiveIndex: 0
}

const mutations = {
 SET_ACTIVE_INDEX: (state, activeIndex) => {
   state.activeIndex = activeIndex
 },
 SET_PROMOTION_ACTIVE_INDEX:(state,activeIndex)=>{
   state.promotionActiveIndex = activeIndex
 },
 SET_OFFICIAL_ACTIVE_INDEX:(state,activeIndex)=>{
   state.officialActiveIndex = activeIndex
 }
}

const actions = {
  changeActiveIndex({ commit }, activeIndex) {
    commit('SET_ACTIVE_INDEX', activeIndex)
  },
  changePromotionActiveIndex({ commit }, activeIndex) {
    commit('SET_PROMOTION_ACTIVE_INDEX', activeIndex)
  },
  changeOfficialActiveIndex({ commit }, activeIndex) {
    commit('SET_OFFICIAL_ACTIVE_INDEX', activeIndex)
  }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/h_nav.js